import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        // Base styles
        "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-2 shadow-sm transition-colors",
        // Text - 16px minimum to prevent iOS zoom
        "text-base placeholder:text-muted-foreground",
        // File input styling
        "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
        // Focus states
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        // Disabled state
        "disabled:cursor-not-allowed disabled:opacity-50",
        // iOS specific: minimum touch target height
        "min-h-[44px]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
